import { useParams } from "react-router-dom";
import "../../styles/agency-lookup.css";
import React, { useEffect, useState } from "react";
import { getAgencies } from "./service";
import DisplayTemplate from "./display-template";
import { getSubdomainFromUrl, checkIsDukePNGPortalSubdomain } from "../../utils/urlUtils";

const Page = () => {
  const [agencies, setAgencies] = useState(undefined);
  const [isLoaded, setIsLoaded] = useState(true);
  const { token } = useParams();

  const companyCode = checkIsDukePNGPortalSubdomain(getSubdomainFromUrl(window.location.href));

  useEffect(() => {
    setIsLoaded(true);

    document.title = companyCode === "PNG" ? "Piedmont Natural Gas" : "Duke Energy";
    
    getAgencies(token).then(agenciesRes => {
      if(agenciesRes && agenciesRes.packet && agenciesRes.packet.length) {
        setAgencies(agenciesRes);
      }
    }).finally(() => {
      setIsLoaded(false);
    });

  }, [token, companyCode]);
  
  return(<div style={{ display: "flex", height: "100%", width: "100%"}}>
    {isLoaded ? 
      <div>Loading...</div> : 
      (agencies ? 
        <DisplayTemplate agencies={agencies} token={token}/> : 
        <div style={{
          margin: "auto",
          width: "50%",
          minWidth: 350,
          padding: 10,}}>
          <img style={{margin: "auto", height: 70, }} src="https://emails.duke-energy.com/brand/logos/logo-de.png" alt="No agencies found" />
          <p style={{
            margin: "auto", 
            textAlign: "center", 
            marginTop: 10,
            fontFamily: "Arial,sans-serif", }}>
            We are sorry, but the link has expired. To find more information about special assistance programs and resources, visit <a href="https://duk.us/103">https://duk.us/103</a>.
          </p>
        </div>)}
  </div>);

}

export default Page;